/*
 * @Descripttion:
 * @Date: 2024-08-06 10:12:42
 */
import http from '@/utils/http/axios';
import type { ListPage } from './types';
import { ContractMenuType, ContractType } from '../constants';

const yApiObj = {
  // yapi: 1263
};

enum Api {
  listPage = '/front-end/ht/contract/list', // 合同列表
  getContractDetail = '/front-end/ht/contract/info', // 获取合同详情
  downloadContract = '/front-end/ht/contract/download',
  getParticipatantList = '/back-end/ht/type/participants', // 获取可选的参与方列表
  getContractTypeApi = '/front-end/ht/contract/contractType',
  applyForQuiesceApi = '/front-end/ht/contract/applyForQuiesce', // 合同-申请静默签约
  queryQuiesceApi = '/front-end/ht/contract/queryQuiesce',
  getEnterpriseList = '/back-end/ht/type/participants/entpList', // 企业关联公司-获取企业列表
  getContractUserInfoApi = '/front-end/ht/contract/contractList/userInfo',
  getParticipatantOpt = '/front-end/ht/contract/type/participants', // 列表-参与方选项

  contractAddOrUpdateApi = '/back-end/ht/contract/contractAddOrUpdate', // 编辑合同模板
  platformDicList = '/back-end/ht/contract/platformDicList', // 获取平台标识
  parkList = '/back-end/ht/contract/parkList' // 查询园区-根据代办供应商id
}

/** 编辑合同模板 */
export const addOrUpdateContract = async params => {
  return await http.request(
    {
      url: Api.contractAddOrUpdateApi,
      method: 'POST',
      params
    },
    {
      isParseToJson: true,
      headers: {
        'Content-Type': 'application/json;charset=UTF-8'
      },
      ...yApiObj
    }
  );
};

/**
 * 获取平台标识
 */
export const platformDicList = async params => {
  return await http.request(
    {
      url: Api.platformDicList,
      method: 'POST',
      params: { ...params }
    },
    {
      ...yApiObj
    }
  );
};

/**
 * 查询园区-根据代办供应商
 */
export const parkList = async params => {
  return await http.request(
    {
      url: Api.parkList,
      method: 'POST',
      params: { ...params }
    },
    {
      ...yApiObj
    }
  );
};
/**
 * 合同列表
 */
export const listPage: ListPage = params =>
  http.request(
    {
      url: Api.listPage,
      method: 'POST',
      params
    },
    {
      isParseToJson: true,
      headers: {
        'Content-Type': 'application/json;charset=UTF-8'
      },
      ...yApiObj
    }
  );

/** 获取合同详情 */
export const getContractDetail = async params => {
  return await http.request(
    {
      url: Api.getContractDetail,
      method: 'POST',
      params
    },
    {
      isParseToJson: true,
      headers: {
        'Content-Type': 'application/json;charset=UTF-8'
      },
      ...yApiObj
    }
  );
};
/**
 * 合同下载
 */
export const downloadContract = async params =>
  http.download({
    url: Api.downloadContract,
    method: 'POST',
    params
  });

/**
 * 获取可选的参与方列表
 */
export const getPartOptList = async params => {
  const { data } = await http.request(
    {
      url: Api.getParticipatantList,
      method: 'POST',
      params: { ...params, source: 2, port: 1 }
    },
    {
      // yapi: 1271
    }
  );
  return data;
};

/** 合同-获取当前登录者的合同类型 */
export const getContractType = async params => {
  const { data } = await http.request(
    {
      url: Api.getContractTypeApi,
      method: 'POST',
      params
    },
    {
      ...yApiObj
    }
  );
  return data;
};

/** 合同-申请静默签约 */
export const applyForQuiesce = async params => {
  const { data } = await http.request(
    {
      url: Api.applyForQuiesceApi,
      method: 'POST',
      params
    },
    {
      ...yApiObj
    }
  );
  return data;
};

/** 合同-获取登录的企业，是否开启静默签约 */
export const queryQuiesce = async params => {
  const { data } = await http.request(
    {
      url: Api.queryQuiesceApi,
      method: 'POST',
      params
    },
    {
      ...yApiObj
    }
  );
  return data;
};
/**
 * 获取签署主体对应的企业列表
 */
export const getEnterpriseList = async (
  params: {
    index; // 0-甲方， 1-乙方
    participantValue?: string; // 企业类型 1-工业 2-服务商
    entpName?: string; // 企业名称
    type: number; // 类型
    contractType: number; // 合同类型
    entpId: number;
  },
  entpInfo?
) => {
  const res = await http.request(
    {
      url: Api.getEnterpriseList,
      method: 'POST',
      params: {
        ...params,
        source: params.type === ContractMenuType.TEMPLATE ? 1 : 2,
        contractType: params.contractType,
        pageNum: 1,
        pageSize: 80
      }
    },
    {
      ...yApiObj
    }
  );

  // 乙方 或者
  // 项目服务合同-甲方有，乙方没有
  let hasTemplate = false;
  if (+params.index !== 0) {
    hasTemplate = true;
  }
  if (params.contractType === ContractType.PROJECT) {
    hasTemplate = +params.index === 0 ? true : false;
  }
  let selectedEntp = [];
  const list = [
    ...(params.type === ContractMenuType.TEMPLATE && hasTemplate
      ? [
          {
            id: 'all',
            name: '根据模板选择'
          }
        ]
      : []),
    ...res.data?.list?.map(item => ({
      ...item,
      name: `${item.name}${item.phone ? `(${item.phone?.slice(-4)})` : ''}`
    }))
  ];
  if (entpInfo?.id) {
    if (!list.some(item => item.id === entpInfo.id)) {
      selectedEntp = [entpInfo];
    }
  }
  return {
    ...res,
    data: {
      ...res.data,
      list: [...list, ...selectedEntp]
    }
  };
};

/** 合同管理-列表-企业信息/个人信息 */
export const getContractUserInfo = async params => {
  return await http.request(
    {
      url: Api.getContractUserInfoApi,
      method: 'POST',
      params
    },
    {
      isParseToJson: true,
      headers: {
        'Content-Type': 'application/json;charset=UTF-8'
      },
      ...yApiObj
    }
  );
};

/** 合同管理-列表-签署方下拉选项 */
export const getParticipatantOpt = async params => {
  return await http.request(
    {
      url: Api.getParticipatantOpt,
      method: 'POST',
      params
    },
    {
      isParseToJson: true,
      headers: {
        'Content-Type': 'application/json;charset=UTF-8'
      },
      ...yApiObj
    }
  );
};
